export const CommonReducer = (state = {}, action) => {
    switch (action?.type) {
        case 'NOTIFICATION':
            return {
                ...state,
                notification: action?.payload,
            };
        case 'RESET_NOTIFICATION':
            return {
                ...state,
                notification: '',
            };
            
        default:
            return state;
    }
};
